"use strict";

exports.__esModule = true;
exports.ToggleIcon = exports.StyledAccordion = exports.IconLine = exports.AccordionTitle = exports.AccordionSection = exports.AccordionHeader = exports.AccordionContentInner = exports.AccordionContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _polished = require("polished");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledAccordion = _styledComponents.default.div`
    display: block;
`;
exports.StyledAccordion = StyledAccordion;
const AccordionSection = (0, _styledComponents.default)(({
  children,
  open,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", { ...otherProps,
  children: children
}))`
    background-color: ${({
  theme
}) => theme.colors.accordion.background};
    border: 1px solid ${({
  theme
}) => theme.colors.accordion.border};
    border-radius: 4px;
    margin-bottom: 20px;

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.border}
    ${_styledSystem.position}
`;
exports.AccordionSection = AccordionSection;
const AccordionHeader = _styledComponents.default.div`
    position: relative;
    padding: 20px 60px 20px 20px;
    cursor: pointer;
`;
exports.AccordionHeader = AccordionHeader;
const AccordionTitle = _styledComponents.default.h4`
    font-size: 16px;
    margin: 0;
    text-align: left;
`;
exports.AccordionTitle = AccordionTitle;
const ToggleIcon = _styledComponents.default.div`
    position: absolute;
    top: 17px;
    right: 17px;
    padding: 0;
    color: ${({
  theme
}) => theme.colors.button.primary.text};
    background-color: ${({
  theme
}) => theme.colors.button.primary.background};
    border: 2px solid ${({
  theme
}) => theme.colors.button.primary.border};
    width: 25px;
    height: 25px;
    cursor: pointer;
    outline: none;
    appearance: none;
    border-radius: 50%;

    &:hover,
    &:active,
    &:focus {
        outline: none;
        border-style: solid;
    }

    &:focus {
        box-shadow: 0 0 0 0.2rem ${({
  theme
}) => (0, _polished.rgba)(theme.colors.button.primary.background, 0.25)};
    }
`;
exports.ToggleIcon = ToggleIcon;
const IconLine = _styledComponents.default.span`
    transition: all 250ms ease-in-out;
    display: block;
    position: absolute;
    background-color: ${({
  theme
}) => theme.colors.button.primary.text};
    height: 1px;
    width: 11px;
    top: 10px;
    left: 5px;

    &:nth-child(2) {
        transform: rotate(-90deg);

        ${props => props.open && (0, _styledComponents.css)`
                transform: rotate(0deg);
            `}
    }
`;
exports.IconLine = IconLine;
const AccordionContent = _styledComponents.default.div`
    max-height: ${({
  maxHeight
}) => maxHeight};
    opacity: ${({
  open
}) => open ? 1 : 0};
    overflow: hidden;
    text-align: left;
    transition: max-height 250ms ease-in-out, opacity 500ms linear;
    height: auto;
`;
exports.AccordionContent = AccordionContent;
const AccordionContentInner = _styledComponents.default.div`
    padding: 0 20px 20px 20px;
`;
exports.AccordionContentInner = AccordionContentInner;